export default __webpack_public_path__ + "static/media/branding.39993f24.png";